import React, { FC } from 'react';
import { Card } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { IContentLayoutProps } from 'types/app';
import { useContent } from 'hooks';
import { IPostRenderProps } from 'features/posting';

import { getPhoto, getVideo, hasPhoto, hasVideo } from '../helpers';
import { ContentActions, User } from '../partials';
import { Important, Photo, Video } from '../widgets';

interface IPropsEnhanced extends IContentLayoutProps, IPostRenderProps {}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
    marginBottom: 12,
  },
}));

const Manual: FC<IPropsEnhanced> = ({ selectedGroup, toggleState }) => {
  const classes = useStyles();
  const content = useContent();

  function getContent() {
    if (hasVideo(content)) {
      const video = getVideo(content);
      return <Video video={video} />;
    }

    if (hasPhoto(content)) {
      const photo = getPhoto(content);
      return <Photo photo={photo} />;
    }

    return null;
  }

  return (
    <Card className={classes.root}>
      <Important />
      <User selectedGroup={selectedGroup} toggleState={toggleState} />
      <div className={classes.content}>{getContent()}</div>
      <ContentActions selectedGroup={selectedGroup} toggleState={toggleState} />
    </Card>
  );
};

export default Manual;
